(ns ductile.ui.accessories
  (:require [clojure.string :as str]
            [ductile.ui.components :as ui]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.http :as http]
            [ductile.ui.locale :refer [tr]]
            [ductile.ui.scanner :as scanner]
            [ductile.ui.scene :as scene]
            [ductile.ui.util :as util]
            [nextjournal.log :as log]
            [reagent.core :as r])
  (:require-macros [ductile.ui.scene.macros :refer [defscene]]))

(defn scanner-view []
  (when @deframe/!scan-active?
    [:div.fixed.left-0.top-0.w-screen.h-screen {:style {:z-index 999}}
     [scanner/scanner-view {:width js/innerWidth
                            :height js/innerHeight
                            :scanning-mode (scanner/scan-mode :vin)
                            :scan/context :accessories
                            :on-vin-detected (fn [_state body]
                                               (let [{:keys [vin]} body]
                                                 (deframe/scan! {:scan/attr :vehicle/vin
                                                                 :scan/result vin
                                                                 :scan/ocr-details body
                                                                 :scan/classified (scanner/classify-scan vin)
                                                                 :scan/source :camera})
                                                 (deframe/close-scanner!)))}]
     [:div.fixed.right-2.top-2.text-white.z-10.cursor-pointer
      {:on-click #(deframe/close-scanner!)}
      [ui/icon {:size 30} :x]]]))

(def with-hardware-scanner (partial ui/with-hardware-scanner scanner-view))

(defn clear-state! []
  (deframe/route-dissoc! :accessories)
  (deframe/route-dissoc! ::error)
  (deframe/activate-scanner!)
  (deframe/reset-current-scan!))

(defn vin-not-found [{:keys [scan-result width height]}]
  [:div.bg-slate-100.flex.flex-col
   {:style {:width (or width "100%") :height (or height "100%")}}
   [:div.flex-auto.w-full.overflow-y-auto.text-center
    [:div.font-bold.w-full.px-4.py-3 (tr "No vehicle found (%1). Please make a new scan." scan-result)]]
   [:div.bg-white.shadow-lg.px-4.border-t.flex
    {:class "pt-[10px] pb-[12px]"}
    [:button.text-white.bg-green-500.rounded-lg.text-center.font-bold.px-4.shadow.flex-auto
     {:style {:height 50} :on-click-capture clear-state!}
     [:span (tr "New Scan")]]]])

(defn accessories-list [{:keys [accessories width height vin on-close]}]
  [:div.bg-slate-100.flex.flex-col
   {:style {:width (or width "100%") :height (or height "100%")}}
   [:button.bg-white.shadow-lg.flex.items-center.justify-between.text-gray-900.w-full.pl-4.pr-3.py-3.leading-none
    {:on-click-capture on-close}
    [:div.text-sm.leading-none.uppercase [ui/vin vin]]
    [ui/icon {:size 24} :x]]
   [:div.flex-auto.w-full.overflow-y-auto
    (into [:ul]
          (map
           (fn [{:keys [code description]}]
             [:li.px-4.py-3.border-t.first:border-t-0.flex
              [:div.text-sm.flex-auto description]
              [:div.text-xs.text-gray-500.ml-2 code]])
           accessories))]
   [:div.bg-white.shadow-lg.px-4.border-t.flex
    {:class "pt-[10px] pb-[12px]"}
    [:button.text-white.bg-green-500.rounded-lg.text-center.font-bold.px-4.shadow.flex-auto
     {:style {:height 50} :on-click-capture on-close}
     [:span (tr "New Scan")]]]])

(defn process-scan! []
  (let [{:scan/keys [result]} @deframe/!current-scan]
    (when (and result (#{#_7 17} (count result)))
      (.then (http/$lambda 'ductile.accessories/fetch-item-list
                           {:vehicle/vin result :compound/name (util/current-compound-name)})
             (fn [accessories]
               (if (:error accessories)
                 (deframe/route-assoc! ::error {:error (:error accessories)
                                                :error-message (:error-message accessories)})
                 (deframe/route-assoc! :accessories accessories)))))))

(defn render-accessories [_result _match]
  ;; start with scanner on
  (r/with-let [_ (deframe/activate-scanner!)]
    (with-hardware-scanner
      {:view `accessories
       :on-scan process-scan!}
      (let [accessories @(deframe/!route-get :accessories)
            error @(deframe/!route-get ::error)
            {:scan/keys [result]} @deframe/!current-scan]
        (cond error
              [:div.bg-slate-100.flex.flex-col
               {:style {:width "100%" :height "100%"}}
               [:button.shadow-lg.flex.items-center.justify-between.text-gray-900.w-full.pl-4.pr-3.py-3.leading-none
                {:on-click-capture clear-state!}
                [ui/icon {:size 24} :x]]
               [ui/expected-error-view error]]


              (and result (seq accessories))
              [accessories-list {:accessories accessories
                                 :vin result
                                 :on-close clear-state!}]

              :else
              [vin-not-found {:scan-result result}])))))


(defscene accessories-portrait
  (let [{:as state :keys [width height]}
        {:width 380
         :height 640
         :vin "WVGZZZ5NZJM131395"
         :accessories [{:code "BAOC" :description "SENZA ESTINTORE"}
                       {:code "76AC" :description "SENZA CAVO DI RICARICA MODO 3"}
                       {:code "TUJC" :description "SISTEMA DI MEDIA"}
                       {:code "SARC" :description "INFOTAINMENT BOLERO/AMUNDSEN/COLUMB"}
                       {:code "8ZQC" :description "ANTENNA SOLO PER RICEZIONE FM, DIVER"}
                       {:code "9JAC" :description "PACCHETTO NON FUMATORI ANTERIORE"}
                       {:code "9MOC" :description "SENZA POMPA DI CALORE AD ADRIA/RISC"}
                       {:code "9WJC" :description "SMARTLINK APPLE CARPLAY/ANDRO. AUTO"}
                       {:code "9ZVC" :description "PHONE BOX LIGHT DELL'IMPIANTO RADIO"}
                       {:code "NZ4C" :description "CHIAMATA D'EMERGENZA PRIVATA CONNEC"}]}]
    [:div.rounded-lg.overflow-hidden.shadow-lg.mx-auto.border
     {:style {:width width :height height}}
     [accessories-list state]]))
